import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"; import { CreateNotSQNPIDTO, filtersDTO, NotSQNPIDTO, NotSQNPIDTOResponse, UpdateNotSQNPIDTO } from "./dto";
import { PromiseStatuses } from "../../../../utils";
import { NewNotificationSQNPIService } from "./service";
;

interface NotificationSQNPIState {
    notificationIdToUpdate: string
    // FILTERS
    getAllNotificationFilters: filtersDTO
    getAllNotificationResponse?: NotSQNPIDTOResponse
    createNotSQNPI: CreateNotSQNPIDTO
    updateNotSQNPI: UpdateNotSQNPIDTO
    // STATUS
    getAllNotificationStatus: PromiseStatuses
    createNotSQNPIStatus: PromiseStatuses
    updateNotSQNPIStatus: PromiseStatuses
}

const initialState: NotificationSQNPIState = {
    notificationIdToUpdate: '',
    getAllNotificationStatus: 'idle',
    createNotSQNPIStatus: 'idle',
    updateNotSQNPIStatus: 'idle',
    getAllNotificationFilters: {
        itemsPerPage: 0,
        page: 0
    },
    createNotSQNPI: {
        customerId: ''
    },
    updateNotSQNPI: {
        customerId: ''
    }
}

export const GetNotSQNPI = createAsyncThunk(
    'Not/GetNotSQNPI',
    async (filters: filtersDTO, thunkApi): Promise<NotSQNPIDTOResponse> => {
        const NotSQNPIService = NewNotificationSQNPIService()
        return NotSQNPIService.GetAllNotificationSQNPI(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const UpdateNotSQNPI = createAsyncThunk(
    'Not/UpdateNotSQNPI',
    async (request: { body: UpdateNotSQNPIDTO, id: string }, thunkApi): Promise<void> => {
        const NotSQNPIService = NewNotificationSQNPIService()
        return NotSQNPIService.UpdateNotSQNPI(request.body, request.id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const CreateNotSQNPI = createAsyncThunk(
    'Not/CreateNotSQNPI',
    async (body: CreateNotSQNPIDTO, thunkApi): Promise<void> => {
        const odcService = NewNotificationSQNPIService()
        return odcService.CreateNotSQNPI(body).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const NotificationSQNPISlice = createSlice({
    name: 'notification/slice',
    initialState,
    reducers: {
        setNotificationIdToUpdate: (state, action) => {
            state.notificationIdToUpdate = action.payload
        },
        //CREATE
        setCreationCustomerNotification: (state, action) => {
            state.createNotSQNPI.customerId = action.payload
        },
        setCreationType: (state, action) => {
            state.createNotSQNPI.type = action.payload
        },
        setCreationCampaignYear: (state, action) => {
            state.createNotSQNPI.campaignYear = action.payload
        },
        setCreationRegion: (state, action) => {
            state.createNotSQNPI.region = action.payload
        },
        setCreationNumber: (state, action) => {
            state.createNotSQNPI.number = action.payload
        },
        setCreationProtocol: (state, action) => {
            state.createNotSQNPI.protocol = action.payload
        },
        setCreationProtocolDate: (state, action) => {
            state.createNotSQNPI.protocolDate = action.payload
        },
        setCreationAdhesionType: (state, action) => {
            state.createNotSQNPI.adhesionTypes = action.payload
        },
        setCreationAdhesionDate: (state, action) => {
            state.createNotSQNPI.adhesionDate = action.payload
        },
        setCreationPurpose: (state, action) => {
            state.createNotSQNPI.purpose = action.payload
        },
        setCreationRegionalMark: (state, action) => {
            if (action.payload === 'SI') {
                state.createNotSQNPI.regionalMark = true
            } else {
                state.createNotSQNPI.regionalMark = false
            }

        },
        setCreationConfirmId: (state, action) => {
            state.createNotSQNPI.sqnpiNotificationConfirmationId = action.payload
        },
        setCreationProtocolId: (state, action) => {
            state.createNotSQNPI.requestProtocolId = action.payload
        },
        setCreationRettificationId: (state, action) => {
            state.createNotSQNPI.sqnpiNotificationRectificationId = action.payload
        },
        setCreationNote: (state, action) => {
            state.createNotSQNPI.note = action.payload
        },
        // REQUEST [UPDATE]
        setNotSqnpiUpdateRequest: (state, action) => {
            state.updateNotSQNPI = action.payload
        },
        //update 
        setUpdateCustomerNotification: (state, action) => {
            state.updateNotSQNPI.customerId = action.payload
        },
        setUpdateType: (state, action) => {
            state.updateNotSQNPI.type = action.payload
        },
        setUpdateCampaignYear: (state, action) => {
            state.updateNotSQNPI.campaignYear = action.payload
        },
        setUpdateRegion: (state, action) => {
            state.updateNotSQNPI.region = action.payload
        },
        setUpdateNumber: (state, action) => {
            state.updateNotSQNPI.number = action.payload
        },
        setUpdateProtocol: (state, action) => {
            state.updateNotSQNPI.protocol = action.payload
        },
        setUpdateProtocolDate: (state, action) => {
            state.updateNotSQNPI.protocolDate = action.payload
        },
        setUpdateAdhesionType: (state, action) => {
            state.updateNotSQNPI.adhesionTypes = action.payload
        },
        setUpdateAdhesionDate: (state, action) => {
            state.updateNotSQNPI.adhesionDate = action.payload
        },
        setUpdatePurpose: (state, action) => {
            state.updateNotSQNPI.purpose = action.payload
        },
        setUpdateRegionalMark: (state, action) => {
            if (action.payload === 'SI') {
                state.updateNotSQNPI.regionalMark = true
            } else {
                state.updateNotSQNPI.regionalMark = false
            }

        },
        setUpdateConfirmId: (state, action) => {
            state.updateNotSQNPI.sqnpiNotificationConfirmationId = action.payload
        },
        setUpdateProtocolId: (state, action) => {
            state.updateNotSQNPI.requestProtocolId = action.payload
        },
        setUpdateRettificationId: (state, action) => {
            state.updateNotSQNPI.sqnpiNotificationRectificationId = action.payload
        },
        setUpdateNote: (state, action) => {
            state.updateNotSQNPI.note = action.payload
        },
        //reset
        resetCreateStatus: (state) => {
            state.createNotSQNPIStatus = 'idle'
        },
        resetUpdateStatus: (state) => {
            state.updateNotSQNPIStatus = 'idle'
        },
        resetGetAllStatus: (state) => {
            state.getAllNotificationStatus = 'idle'
        },
        resetCreate: (state) => {
            state.createNotSQNPI = {
                customerId: ''
            }
        },
        resetUpdateForm: (state) => {
            state.updateNotSQNPI = {
                customerId: ''
            }
        },
    },
    extraReducers(builder) {
        builder
            .addCase(GetNotSQNPI.pending, (state) => {
                state.getAllNotificationStatus = 'loading'
            })
            .addCase(GetNotSQNPI.fulfilled, (state, action) => {
                state.getAllNotificationStatus = 'successfully'
                state.getAllNotificationResponse = action.payload
            })
            .addCase(GetNotSQNPI.rejected, (state, action) => {
                state.getAllNotificationStatus = 'failed'
            })

            .addCase(CreateNotSQNPI.pending, (state) => {
                state.createNotSQNPIStatus = 'loading'
            })
            .addCase(CreateNotSQNPI.fulfilled, (state, action) => {
                state.createNotSQNPIStatus = 'successfully'
            })
            .addCase(CreateNotSQNPI.rejected, (state, action) => {
                state.createNotSQNPIStatus = 'failed'
            })

            .addCase(UpdateNotSQNPI.pending, (state) => {
                state.updateNotSQNPIStatus = 'loading'
            })
            .addCase(UpdateNotSQNPI.fulfilled, (state, action) => {
                state.updateNotSQNPIStatus = 'successfully'
            })
            .addCase(UpdateNotSQNPI.rejected, (state, action) => {
                state.updateNotSQNPIStatus = 'failed'
            })
    },
})

export const {
    setNotificationIdToUpdate,
    setCreationAdhesionDate,
    setCreationAdhesionType,
    setCreationCampaignYear,
    setCreationConfirmId,
    setCreationCustomerNotification,
    setCreationNumber,
    setCreationProtocol,
    setCreationProtocolDate,
    setCreationPurpose,
    setCreationRegion,
    setCreationRegionalMark,
    setCreationRettificationId,
    setCreationType,
    setCreationProtocolId,
    setCreationNote,
    setNotSqnpiUpdateRequest,
    //update
    setUpdateAdhesionDate,
    setUpdateAdhesionType,
    setUpdateCampaignYear,
    setUpdateConfirmId,
    setUpdateCustomerNotification,
    setUpdateNote,
    setUpdateNumber,
    setUpdateProtocolDate,
    setUpdateProtocolId,
    setUpdateProtocol,
    setUpdatePurpose,
    setUpdateRegion,
    setUpdateRegionalMark,
    setUpdateRettificationId,
    setUpdateType,
    //reset
    resetCreate,
    resetCreateStatus,
    resetGetAllStatus,
    resetUpdateForm,
    resetUpdateStatus,
} = NotificationSQNPISlice.actions

export default NotificationSQNPISlice.reducer